import { render, staticRenderFns } from "./DialogEmployeeWithSettlementItems.vue?vue&type=template&id=5766c1b0"
import script from "./DialogEmployeeWithSettlementItems.vue?vue&type=script&lang=js"
export * from "./DialogEmployeeWithSettlementItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports